// ./client/src/utilities/axiosInstance.js

import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: '', // Empty - same origin, no need for full URL
  timeout: 100000,
  // No need for withCredentials since it's same-origin
  withCredentials: true,  // ✅ CHANGED - Send cookies
});

axiosInstance.interceptors.request.use(
  (config) => {
    // ✅ NO MORE Authorization header - cookies sent automatically
    
    if (process.env.NODE_ENV === 'development') {
      console.log('API Request:', config.method?.toUpperCase(), config.url);
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => {
    // Debug logging (remove in production)
    console.log('API Response:', response.status, response.config.url);
    return Promise.resolve(response);
  },
  (error) => {
    console.error('API Error:', error.response?.status, error.config?.url);
    
    // ⭐ ONLY redirect on auth errors for non-delete requests
    // Let the delete account component handle its own logout
    const isDeleteRequest = error.config?.url?.includes('/deleteUser');
    console.log("is Delete Request: ", isDeleteRequest);
    
    if ((error.response?.status === 401 || error.response?.status === 403) && !isDeleteRequest) {
      console.error('Auth error - redirecting to login');
      localStorage.removeItem('userRole');  // ✅ Only remove userRole
      window.location.href = '/';
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;